"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WriteOffProject = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var coupon_1 = require("../../model/coupon");
var service_1 = require("../../../library/base/service");
var WriteOffProject = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(WriteOffProject, _super);
    function WriteOffProject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取项目列表';
        _this.code = '300007';
        _this.desc = '获取项目列表';
        _this.requestParams = new coupon_1.WriteOffProjectRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return WriteOffProject;
}(service_1.BaseService));
exports.WriteOffProject = WriteOffProject;
//# sourceMappingURL=writeOffProject.js.map